import { fetchGet } from 'helpers/utils'
import { getParam } from '../../helpers/parameters'
import { getCustomer } from '../../helpers'

export const fetchRelatedApi = async (datatype, id, phone) => {
  const suggestedApiV2Url = await getParam('suggestedContentV2ApiUrl')
  const customer = getCustomer()
  const v2 = await fetchGet(`${suggestedApiV2Url}/suggested_content`, {
    datatype,
    id,
    phone,
    customer
  })
  return v2
}
